/**
 * @description: 中文说明
 * @author: zb
 * @update: zb
 * @Date: 2019-05-27 09:30:47
 * @LastEditors: zb
 * @LastEditTime: 2019-05-27 09:30:47
 */

export class Page {
  constructor(... args) {
    this.pageNo = args[0] || 1
    this.pageSize = args[1] || 10
    this.total = args[2] || 0
  }
  pageNo;
  pageSize;
  total
}
